import { useEffect, useRef } from 'react';

const AnimatedBackground = () => {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        // Set canvas size to window size
        const resizeCanvas = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };
        resizeCanvas();
        window.addEventListener('resize', resizeCanvas);

        // Create gradient blobs for Foundation Elite theme
        const blobs = Array.from({ length: 6 }, (_, i) => ({
            x: Math.random() * canvas.width,
            y: Math.random() * canvas.height,
            radius: Math.random() * 180 + 120,
            vx: (Math.random() - 0.5) * 0.3,
            vy: (Math.random() - 0.5) * 0.3,
            color: i % 3 === 0 ? 'navy' : i % 3 === 1 ? 'gold' : 'slate',
        }));

        // Animation loop
        const animate = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            blobs.forEach(blob => {
                // Update position
                blob.x += blob.vx;
                blob.y += blob.vy;

                // Bounce off edges
                if (blob.x < 0 || blob.x > canvas.width) blob.vx *= -1;
                if (blob.y < 0 || blob.y > canvas.height) blob.vy *= -1;

                // Create gradient based on blob color
                const gradient = ctx.createRadialGradient(
                    blob.x, blob.y, 0,
                    blob.x, blob.y, blob.radius
                );
                
                if (blob.color === 'navy') {
                    gradient.addColorStop(0, 'rgba(30, 58, 138, 0.08)');
                    gradient.addColorStop(1, 'rgba(30, 58, 138, 0)');
                } else if (blob.color === 'gold') {
                    gradient.addColorStop(0, 'rgba(245, 158, 11, 0.06)');
                    gradient.addColorStop(1, 'rgba(245, 158, 11, 0)');
                } else {
                    gradient.addColorStop(0, 'rgba(71, 85, 105, 0.05)');
                    gradient.addColorStop(1, 'rgba(71, 85, 105, 0)');
                }

                // Draw blob
                ctx.beginPath();
                ctx.arc(blob.x, blob.y, blob.radius, 0, Math.PI * 2);
                ctx.fillStyle = gradient;
                ctx.fill();
            });

            requestAnimationFrame(animate);
        };

        animate();

        return () => {
            window.removeEventListener('resize', resizeCanvas);
        };
    }, []);

    return (
        <canvas
            ref={canvasRef}
            className="fixed inset-0 w-full h-full pointer-events-none"
        />
    );
};

export default AnimatedBackground; 